export default {
  yellow: '',
  textYellow: '#777146',
  green: '',
  textGreen: '#547255',
  blue: '',
  textBlue: '#3F7F82',
  red: 'red',
  gray: '#494949',
  white: 'white',
  black: 'black'
}



// WEBPACK FOOTER //
// ./src/constants/colors.js